import { render, staticRenderFns } from "./ImportItemModal.vue?vue&type=template&id=0409aae2&scoped=true"
import script from "./ImportItemModal.vue?vue&type=script&lang=js"
export * from "./ImportItemModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0409aae2",
  null
  
)

export default component.exports